import { Button } from '@cian/ui-kit/button';
import * as React from 'react';

import * as styles from './LoadableError.css';

interface ILoadableErrorProps {
  text?: string;
  onRetry(): void;
}

export function LoadableError({ text, onRetry }: ILoadableErrorProps) {
  return (
    <div className={styles['container']}>
      <p className={styles['text']}>
        {text ||
          'Во время загрузки произошла ошибка. Пожалуйста, проверьте своё интернет соединение и попробуйте ещё раз.'}
      </p>
      <Button onClick={onRetry}>Повторить</Button>
    </div>
  );
}
